api = require '../api'
_ = require 'lodash'

module.exports =

  fetchall: (classroomId) ->
    api.send
      method: 'GET'
      path: "/api/v2/permissionforms/classrooms/#{classroomId}"
